export class State {
  iotVendorConfigs: any = [];

  userIotVendorConfigs: any = {};
}
